export default "__VITE_ASSET__d3144c3a__"